import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";
import Pagination from "../../../common/Pagination";
import Swal from "sweetalert2";
import { SizeList, DeleteSize, SizeChangeStatus } from "../../../redux/services/UnitSize/unit-size.Services";

function AllSizeList() {
  const dispatch = useDispatch();
  const [totalRecords, setTotalRecords] = useState(0);
  const [size, setSize] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const refreshData = useSelector((state) => state.productModal.refreshData);
  const [loading, setLoading] = useState(false);
  const fetchSize = async () => {
    try {
      setLoading(true);
      const payload = {
        page,
        search,
        status,
      };
      const res = await SizeList(payload);
      if (res.success) {
        setSize(res.data || []);
        setLastPage(res?.data?.last_page || 1);
        setTotalRecords(res?.data?.total || 0);
      }

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSize();
  }, [page, search, status, refreshData]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Size List</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Size </span>
              </nav>
            </div>
          </div>
          <button
            className="add-btn"
            onClick={() =>
              dispatch(
                openProductModal({
                  type: "create-size",
                  title: "Create Size",
                  data: {
                    refreshData: fetchSize,
                  },
                }),
              )
            }
          >
            + Add Size
          </button>
        </div>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search.trim() !== "") && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Size..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Size</th>
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {size.length > 0 ? (
                  size.map((item, index) => (
                    <tr key={item.id}>
                        <td> {(page - 1) * limit + index + 1}</td>
                      <td>{item.size_name}</td>
                      <td>{item.category_details?.name}</td>
                      <td>{item.subcategory_details?.name}</td>
                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item._id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status: item.status ? "Active" : "Inactive",
                                    statusFunction: SizeChangeStatus,
                                    onSuccess: fetchSize,
                                  },
                                })
                              )
                            }
                          />

                          <label
                            htmlFor={`status-${item._id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>

                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>

                        </div>
                      </td>



                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "view-size",
                                  title: "View size",
                                  data: item,
                                })
                              )
                            }
                          >
                            <FaEye />
                          </button>

                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "edit-size",
                                  title: "Edit size",
                                  data: {
                                    ...item,
                                    refreshData: fetchSize,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-size",
                                  title: "Delete size",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteSize,
                                    refreshData: fetchSize,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllSizeList;
